import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { FormLabel } from '@components/form-label';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';
import { useToaster } from '@components/toaster';

import { useModel } from 'hooks/useModel';
import { useStore } from 'models/Provider';

import { KjarniSettings } from './Models';

export const KjarniSettingsPage = observer(() => {
  const { t, api } = useStore();
  const { showError, showSuccess } = useToaster();
  const model = useModel(KjarniSettings, {}, { api, showError, showSuccess, t });

  return (
    <Stack space={4}>
      <div>
        <Text font="heading2" text={t('integrations.kjarni.settings.header')} />
        <Text text={t('integrations.kjarni.settings.instructions')} />
      </div>
      <Stack space={1}>
        <FormLabel text={t('integrations.kjarni.settings.emails.label')} />
        {model.notifyEmails.map((email, idx) => (
          <TextField
            key={idx}
            hideLabel
            label={t('integrations.kjarni.settings.emails.label')}
            onChange={email.setValue}
            defaultValue={email.value}
            onBlur={email.onBlur}
            error={
              email.valid || email.value === ''
                ? null
                : t('integrations.kjarni.settings.emails.error')
            }
            autoFocus={email.value === ''}
          />
        ))}
      </Stack>
      <Button
        isDisabled={model.hasInvalid}
        onClick={model.submitEmails}
        text={t('integrations.kjarni.settings.submit')}
      />
    </Stack>
  );
});
